export default __webpack_public_path__ + "static/media/Services - payroll-services.ffdc85ca.jpg";